import { API } from "../../constant/apiConstant";
const CASH_OUT_TIMEOUT_MS = 25000;

async function parseJsonResponse(response) {
  const rawText = await response.text();

  if (!rawText) {
    return {};
  }

  try {
    return JSON.parse(rawText);
  } catch (_error) {
    return {
      status: response.ok,
      message: rawText
    };
  }
}

export const WalletService = {

     getBalance: async()=>{
      try {
       
      const response = await fetch(`${API.BASE_URL}/api/wallet/`, {
        method: "GET",
        credentials:"include"
      });
    const json = await response.json();
    return json;
    } catch (error) {
      console.error("Error fetching wallet data:", error);
      throw error;
    }

},
getHistory :async()=>{
      try {
      const response = await fetch(`${API.BASE_URL}/api/wallet/history`, {
        method: "GET",
        credentials:"include",
        headers: {
           "Content-Type": "application/json",

        },
      });
    const json = await response.json();
    return json;
    } catch (error) {
      console.error("Error fetching wallet data:", error);
      throw error;
    }

},
cashOut: async(amount)=>{
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), CASH_OUT_TIMEOUT_MS);
      try {
      const response = await fetch(`${API.BASE_URL}/api/payout/withdraw`, {
        method: "POST",
        credentials:"include",
        signal: controller.signal,
        headers: {
           "Content-Type": "application/json",
        },
        body: JSON.stringify({ amount })
      });
      const json = await parseJsonResponse(response);
      return json;
    } catch (error) {
      if (error?.name === "AbortError") {
        throw new Error("Cash out request timed out. Please try again.");
      }
      console.error("Error cashing out wallet:", error);
      throw error;
    } finally {
      clearTimeout(timeoutId);
    }

}
} 
